import * as yup from "yup";

export const EmployeeAssignemntValidationSchema = yup.object().shape({
  // employeeStatus: yup
  // .number()
  // .required("Employee Status is required"),
  // date: yup
  // .string()
  // .required("Employee Date is required"),

});
